export const coopType =  [
    
    {
      name: "合作教练",
      value: 1,
    },
    {
      name: "驻店教练",
      value: 2,
    },
    {
      name: "类目主理",
      value: 3,
    },
    {
      name: "合伙人",
      value: 4,
    }
  ]

//账期
  export const accountPeriod =  [
    
    {
      name: "实时结算",
      value: '0',
    },
    {
      name: "月结",
      value: 'm1',
    },
    {
      name: "每月1号",
      value: 'day1',
    },
    {
      name: "7天",
      value: 'n7',
    }
  ]